import { render, staticRenderFns } from "./DispensingOrderComponent.vue?vue&type=template&id=0dab0638"
import script from "./DispensingOrderComponent.vue?vue&type=script&lang=js"
export * from "./DispensingOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports